import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { exchangesApi } from 'src/api';

import { ROUTE } from 'src/constants';
import { normalizeFiltersResponse } from 'src/utils';
import { setReceiveExchanges } from './exchanges.slice';

export const getExchanges = createAsyncThunk('exchanges/get-exchanges', async (data) => {
  try {
    const response = await exchangesApi.getExchanges(data);

    return response?.data;
  } catch (error) {
    console.error(error);
  }
});

export const getWeGoldExchanges = createAsyncThunk(
  'exchanges/get-we-gold-exchanges',
  async (data, thunkApi) => {
    try {
      const { id, payload } = data;

      const response = await exchangesApi.getWeGoldExchanges(id, payload);

      thunkApi.dispatch(setReceiveExchanges(response?.data?.[0]));

      return response?.data?.[0]?.currency;
    } catch (error) {
      console.error(error);
    }
  },
);

export const getGivenExchangesLabels = createAsyncThunk(
  'exchanges/get-given-exchanges-labels',
  async (data) => {
    try {
      const response = await exchangesApi.getGivenExchangesLabels(data);

      return normalizeFiltersResponse(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const getReceivedExchangesLabels = createAsyncThunk(
  'exchanges/get-received-exchanges-labels',
  async (data) => {
    try {
      const response = await exchangesApi.getReceivedExchangesLabels(data);

      return normalizeFiltersResponse(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const getExchangesEdit = createAsyncThunk('exchanges/get-exchanges-edit', async (data) => {
  try {
    const { id } = data;

    const response = await exchangesApi.getExchangesEdit(id);

    let personal_fields = response?.data?.personal_fields || [];
    let details_of_the_currency_received = response?.data?.details_of_the_currency_received || [];

    if (data?.we_gold_id) {
      details_of_the_currency_received = response?.data?.details_of_the_currency_received?.map(
        (item) =>
          item?.field_name === 'details_of_the_currency_received'
            ? { ...item, name: data?.we_gold_id }
            : item,
      );
    }

    if (!_.isEmpty(response?.data?.user)) {
      personal_fields = response?.data?.personal_fields?.map((item) =>
        item?.field_name === 'email' ? { ...item, name: response?.data?.user?.email } : item,
      );
    }

    return { ...response?.data, personal_fields, details_of_the_currency_received };
  } catch (error) {
    const { response } = error;

    const { navigate } = data;

    if (navigate) {
      navigate(ROUTE.HOME);
    }

    toast(response?.data?.message, { type: 'error', position: 'top-right' });
    console.error(error);
  }
});

export const getExchangesGivenMerchant = createAsyncThunk(
  'exchanges/get-exchanges-given-merchant',
  async (data) => {
    try {
      const response = await exchangesApi.getExchangesGivenMerchant(data);

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const getExchangesReceivedMerchant = createAsyncThunk(
  'exchanges/get-exchanges-received-merchant',
  async (data) => {
    try {
      const response = await exchangesApi.getExchangesReceivedMerchant(data);

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const getExchangesParsers = createAsyncThunk(
  'exchanges/get-exchanges-parsers',
  async (data) => {
    try {
      const response = await exchangesApi.getExchangesParsers(data);

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const getStatuses = createAsyncThunk('exchanges/get-statuses', async (data) => {
  try {
    const response = await exchangesApi.getStatuses(data);

    return response?.data;
  } catch (error) {
    console.error(error);
  }
});
